import { getAuthProvider } from './auth-provider';
import type { SessionHttp } from './interfaces';
import * as $session from './session';
import * as $sessionHttp from './session-http';

export function callback(data: SessionHttp.Salesforce.Params): Promise<{ type: 'redirect'; returnUrl: string }> {
  return $sessionHttp.salesforce(data)
    .then(async (session) => {
      await getAuthProvider().authenticate({
        authSource: 'cookie',
        sessionMeta: {
          authenticated: session.authenticated,
          expiry: session.expiry,
        },
      });

      $session.setLastLoginStrategy({
        strategy: 'enterprise',
        identifier: 'salesforce',
        endSessionUrl: session.endSessionUrl,
      });

      return Promise.resolve({
        type: 'redirect',
        returnUrl: session.returnUrl ?? '/home',
      });
    });
}
